export default "/build/client/static/fonts/SoderbergSans-RegularItalic.woff";